import { baseApi, getQueryArgs, transformErrorResponse } from 'store/api'
import { ProfileDetails } from 'store/api/profiles/profiles.interface'
import { ApiResponse } from 'store/api/http'

export interface FeaturedProfile {
  PK: string
  updated: number
  name: string
  profile: ProfileDetails
}

export type FeaturedProfilesResponse = ApiResponse<{ profiles: FeaturedProfile[] }>

export const featuredProfilesApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    getProfilesFeatured: builder.query({
      query: ({ selectedProductId }: { selectedProductId: string }) =>
        getQueryArgs(
          `/profiles/featured${selectedProductId ? `?product=${selectedProductId}` : ''}`,
        ),
      transformResponse: (response: FeaturedProfilesResponse) => response.body.profiles,
      transformErrorResponse,
      providesTags: () => ['FeaturedProfiles'],
    }),
    getOrgFeaturedProfiles: builder.query({
      query: () => getQueryArgs(`/profiles/featured/org`),
      transformResponse: (response: FeaturedProfilesResponse) => response.body.profiles,
      transformErrorResponse,
    }),
  }),
})

export const { endpoints, useGetProfilesFeaturedQuery, useGetOrgFeaturedProfilesQuery } =
  featuredProfilesApi
